import React from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';

const EditBucketModal = ({ show, onHide, bucketForm, onChange, onUpdate, isLoading }) => {
    const handleChange = (e) => {
        const { name, value } = e.target;
        onChange({ ...bucketForm, [name]: value });
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Bucket</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Bucket Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={bucketForm.name}
                            onChange={handleChange}
                            placeholder="Enter bucket name"
                            required
                        />
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="description"
                            value={bucketForm.description}
                            onChange={handleChange}
                            placeholder="Enter bucket description"
                            rows={3}
                        />
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Color</Form.Label>
                        <div className="d-flex">
                            <Form.Control
                                type="color"
                                name="color"
                                value={bucketForm.color}
                                onChange={handleChange}
                                className="mr-2"
                                style={{ width: '50px' }}
                            />
                            <Form.Control
                                type="text"
                                name="color"
                                value={bucketForm.color}
                                onChange={handleChange}
                                placeholder="Enter color hex code"
                            />
                        </div>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onUpdate} disabled={!bucketForm.name || isLoading}>
                    {isLoading ? <Spinner animation="border" size="sm" /> : 'Update Bucket'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditBucketModal;
